module.exports = __webpack_public_path__ + "img/java.cc096197.png";